import { render } from "./TransactionDetails.vue?vue&type=template&id=333d6abb&scoped=true&ts=true"
import script from "./TransactionDetails.vue?vue&type=script&lang=ts"
export * from "./TransactionDetails.vue?vue&type=script&lang=ts"

import "./TransactionDetails.vue?vue&type=style&index=0&id=333d6abb&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-333d6abb"]])

export default __exports__